import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Answer } from 'src/app/models/Answer.model';
import { ModularQuestion } from 'src/app/models/modularQuestion.model';
import { AnswerSwitchTypePipe } from '../../../genery-column/answer-switch-type.pipe';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-answer-row-to-group',
    imports: [CommonModule, AnswerSwitchTypePipe, TranslateDirective, TranslatePipe],
    templateUrl: './answer-row-to-group.component.html',
    styleUrls: ['./answer-row-to-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswerRowToGroupComponent implements OnInit {
  @Input() order?: number;
  @Input() answers?: Answer[];
  @Input() modularQuestions?: ModularQuestion[];
  #storeData = inject(DataSummaryStore);
  showComparison$ = toSignal(this.#storeData.showComparison$);

  answersSignal$ = signal<Answer[] | null>(null);
  sortedModularQuestions$ = signal<ModularQuestion[] | null>(null);

  myAnswersSignal$ = computed(() => {
    if (this.sortedModularQuestions$() && this.answersSignal$()) {
      return this.sortedModularQuestions$()?.map(mq => {
        var answer = this.answersSignal$()?.find(ans => (ans?.modularRowNum??-1) == this.order && ans.modularQuestionGuid == mq.guid);
        return { modularQuestion: mq, answer }
      });
    }
    else
    return [];
  });

  ngOnInit(): void {
    if (this.modularQuestions) {
      this.sortedModularQuestions$.set(
        ...[this.modularQuestions.sort((a, b) => {
          const orderA = a?.order ?? Number.POSITIVE_INFINITY;
          const orderB = b?.order ?? Number.POSITIVE_INFINITY;
          return orderA - orderB;
        })]);
    }
    if (this.answers) {
      this.answersSignal$.set(this.answers);
    }

  }
}
